import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontSize: 12,
  },
  palette: {
    info: {
      main: "#5bc0de",
    },

    // primary: {
    //   main: "#337ab7",
    // },
    // success: {
    //   main: "#5cb85c",
    // },
    // error: {
    //   main: "#d9534f",
    // },
    // warning: {
    //   main: "#f0ad4e",
    // },
    // dark: {
    //   main: "#337ab7",
    // },
    // light: {
    //   main: "#337ab7",
    // },
    // link: {
    //   main: "#337ab7",
    // },
  },
});

export default theme;